/* eslint-disable */

import api, { BASE_URL } from "../api";

let defaultProfile = {
  id: null,
  username: null,
  name: null,
  first_name: null,
  last_name: null,
  email: null,
  date_joined: null,
  account: null
};

const state = {
  loading: false,
  profile: defaultProfile,
  error: null
};

// getters
const getters = {

};

// actions
const actions = {
  initProfile: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(`${BASE_URL}/users/profile/`)
      .then(response => response.data)
      .then(data => {
        context.commit("SET_PROFILE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  }
};

// mutations
const mutations = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error
  }
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
};
